import {
  MojoLogo,
  RateChecker,
  RateCheckerDetails,
  RateCheckerFAQLink,
  RateCheckerImage,
  RateCheckerPromiseImage,
  RateCheckerTitle,
  RateCheckPromiseTitle,
} from "pages/Application/Recommendation/Recommendation.styles"
import Mojo from "url:assets/images/Logo_Mojo.svg"
import RateCheckerImg from "url:assets/images/rateChecker-latest.png"
import PhoneRateCheckNotification from "url:assets/images/phone-rate-check-notification.svg"
import React from "react"

interface RateCheckerSectionProps {
  inRateCheckExperiment: boolean
}

export const RateCheckerSection = ({ inRateCheckExperiment }: RateCheckerSectionProps) => {
  return (
    <RateChecker>
      {inRateCheckExperiment ? (
        <>
          <RateCheckerDetails>
            <RateCheckPromiseTitle>Rate Check Promise</RateCheckPromiseTitle>
            <p>
              Once you have had an offer accepted by a lender, we’ll check you’re still on the
              lowest rate for the mortgage deal you’ve chosen and will let you know of changes all
              the way until you complete. If we find a lower rate for your deal, we’ll let you know.
            </p>
          </RateCheckerDetails>
          <RateCheckerPromiseImage
            src={PhoneRateCheckNotification}
            alt="Example of a Rate Check Promise"
          />
        </>
      ) : (
        <>
          <RateCheckerDetails>
            <RateCheckerTitle>
              <MojoLogo src={Mojo} />
              <span>Rate Checker</span>
            </RateCheckerTitle>
            <span>Waiting for rates to fall?</span>
            <p>
              {`Applying now secures today’s recommended rate. If rates drop later, ask us to re-check 60+ lenders and we’ll help you reapply for a lower rate—anytime between the offer and 30 days before completion`}
            </p>
            <RateCheckerFAQLink href={"https://mojomortgages.com/mojo-rate-checker"}>
              View the FAQs
            </RateCheckerFAQLink>
          </RateCheckerDetails>
          <RateCheckerImage src={RateCheckerImg} />{" "}
        </>
      )}
    </RateChecker>
  )
}
